<template>
  <div class="head">

    <nav class="navbar navbar-expand-lg">

      <AccesskeyLink class="accesskey_go" id="accesskey_go" target="accesskey_c" accesskey="c" :aria-label="$t('跳到中間主要內容區')">
        {{ $t('跳到中間主要內容區') }}
      </AccesskeyLink>

      <AccesskeyLink target="accesskey_u" accesskey="u" :aria-label="$t('上方區塊')">
        {{ $t(':::') }}
      </AccesskeyLink>

      <div class="container">

        <div class="menu_box">

          <div class="top_box">

            <div class="logo_box">
              <a href="#/" title="首頁">
                <h1>
                  <img :src="logoUrl" alt="">
                </h1>
              </a>
            </div>

            <ul class="subMenu rwd_none">

              <li class="link_box">
                <a v-for="(item, index) in subMenuLinkItems" :key="index" 
                  v-if="item.to" :href="'#' + item.to" class="sub_btn"
                  :title="$t(item.titleKey)">
                  <p>{{ $t(item.titleKey) }}</p>
                </a>
                <span v-else class="sub_btn" :title="$t(item.titleKey)">
                  <p>{{ $t(item.titleKey) }}</p>
                </span>
              </li>

              <li>
                <div class="fontSize_box">
                  <p id="fontSizeLabel" class="fontSizeLabel">{{ $t('字級') }}</p>

                  <div class="fontSize" role="radiogroup" aria-labelledby="fontSizeLabel">
                    <button v-for="size in sizes" :key="size.label" role="radio"
                      :aria-checked="currentSize.label === size.label"
                      :class="['size', { active: currentSize.label === size.label }]" @click="selectSize(size)"
                      @keydown.enter.space.prevent="selectSize(size)">
                      <p>{{ $t(size.label) }}</p>
                    </button>
                  </div>
                </div>

                <div class="language_group">
                  <button ref="languageWrap" :class="['language_btn', { 'active': isLanguageOpen }]"
                    @click.stop="toggleLanguage" aria-haspopup="true" :aria-expanded="isLanguageOpen.toString()"
                    @keydown.esc="isLanguageOpen = false">
                    <img src="img/language_icon.svg" alt="icon" aria-hidden="true">
                    <p>{{ currentLanguage }}</p>
                  </button>

                  <div class="language_box" v-show="isLanguageOpen" role="menu" :aria-label="$t('語言選擇')">
                    <button :class="['language', { active: currentLanguage === item.label }]"
                      v-for="item in languageItem" :key="item.label" role="menuitemradio"
                      :aria-checked="currentLanguage === item.label" @click="selectLanguage(item)">
                      {{ item.label }}
                    </button>

                  </div>
                </div>
              </li>

              <li class="social_group">
                <div class="social_box">
                  <a class="social" v-for="item in socialItem" :href="item.href" :title="item.title + '（' + $t('另開新視窗') + '）'"
                    target="_blank">
                    <img :src="item.src" :alt="item.title">
                  </a>
                </div>

              </li>
            </ul>

          </div>

          <button :class="['navbar-toggler', { open: isOpen }]" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent"
            aria-expanded="false" :aria-label="$t('Toggle navigation')" @click="toggleMenu">
            <span class="line1"></span>
            <span class="line2"></span>
            <span class="line3"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarToggleExternalContent">

            <div class="box">

              <ul class="subMenu web_none">

                <li class="link_box">
                  <a v-for="(item, index) in subMenuLinkItems" :key="index" 
                    v-if="item.to" :href="'#' + item.to" class="sub_btn"
                    :title="$t(item.titleKey)">
                    <p>{{ $t(item.titleKey) }}</p>
                  </a>
                  <span v-else class="sub_btn" :title="$t(item.titleKey)">
                    <p>{{ $t(item.titleKey) }}</p>
                  </span>
                </li>

                <li>
                  <div class="social_box">
                    <a class="social" v-for="item in socialItem" :href="item.href" :title="item.title + '（' + $t('另開新視窗') + '）'"
                      target="_blank">
                      <img :src="item.src" :alt="item.title">
                    </a>
                  </div>
                </li>

              </ul>

              <ul class="navbar-nav menu">
                <li class="nav_item" v-for="(item, index) in menuItems" :key="index"
                  :class="{ dropdown: item.children }">

                  <!-- 有子選單：用 a 觸發 dropdown，不跳轉 -->
                  <a v-if="item.children" class="nav_link dropdown_toggle" href="#" role="button"
                    :id="'navbarDropdown' + index" data-bs-toggle="dropdown" aria-expanded="false"
                    @click.prevent="toggleDropdown(index)" :title="item.title">
                    {{ item.title }}
                  </a>

                  <!-- 沒有子選單：判斷是外部連結、內部連結或無連結 -->
                  <a v-else-if="item.isExternal" class="nav_link" :href="item.link" :target="item.target" 
                    role="button" :title="item.title">
                    {{ item.title }}
                  </a>
                  <a v-else-if="item.link" class="nav_link" :href="'#' + item.link" role="button" :title="item.title">
                    {{ item.title }}
                  </a>
                  <span v-else class="nav_link" :title="item.title">
                    {{ item.title }}
                  </span>

                  <!-- 第二層選單 -->
                  <div v-if="item.children" class="dropdown-menu" :aria-labelledby="'navbarDropdown' + index">

                    <div class="dropdown_box container">
                      <div class="title">
                        <img src="img/menu_icon.svg" alt="">
                        <p>{{ item.title }}</p>
                      </div>
                      <ul class="dropdown_children ">
                        <li v-for="(child, cIndex) in item.children" :key="cIndex" :ref="`childItem-${index}`" :class="{
                          lastInRow: item.lastInRowIndex && item.lastInRowIndex.includes(cIndex),
                          lastRow: item.lastRowIndex && item.lastRowIndex.includes(cIndex)
                        }">
                          <!-- 子選單判斷外部連結、內部連結或無連結 -->
                          <a v-if="child.isExternal" class="dropdown_item" :href="child.link" :target="child.target" 
                            :title="child.title">
                            <p>{{ child.title }}</p>
                          </a>
                          <a v-else-if="child.link" class="dropdown_item" :href="'#' + child.link" :title="child.title">
                            <p>{{ child.title }}</p>
                          </a>
                          <span v-else class="dropdown_item" :title="child.title">
                            <p>{{ child.title }}</p>
                          </span>
                        </li>
                      </ul>
                    </div>

                  </div>
                </li>
              </ul>

            </div>

          </div>
        </div>

      </div>

    </nav>

  </div>
</template>

<script>

import AccesskeyLink from '@/views/AccesskeyLink.vue'

export default {
  name: 'Head',
  components: {

    AccesskeyLink,
  },

  data() {
    return {

      // 站台圖示
      logoUrl: 'img/logo.png',

      // 漢堡紐開合
      isOpen: false,

      // 主選單 (將從 API 載入)
      menuItems: [],

      // 次選單連結
      subMenuLinkItems: [
        {
          titleKey: "首頁",
          to: "/",
        },
        {
          titleKey: "網站導覽",
          to: "/SiteMap",
        },
      ],

      // 字體大小
      currentSize: {
        label: "中",
        value: "1rem",
      },
      sizes: [
        {
          label: "大",
          value: "1.1rem",
        },
        {
          label: "中",
          value: "1rem",
        },
        {
          label: "小",
          value: "0.9rem",
        }
      ],


      // 語言切換
      isLanguageOpen: false,
      languageItem: [
        { label: "繁體中文", },
        { label: "ENGLISH", },
        { label: "日本語", },
      ],

      // 社交軟體
      socialItem: [
        {
          title: "FB",
          src: require('/public/img/fb_black.svg'),
          href: "https://www.facebook.com/longtianchacha",
        },
        {
          title: "IG",
          src: require('/public/img/ig_black.svg'),
          href: "https://www.instagram.com/longtian_chacha/",
        },
        {
          title: "YOUTUBE",
          src: require('/public/img/youtube_black.svg'),
          href: "https://www.youtube.com/channel/UC0JaFGw0FwjZVsmt2bTJ6ew",
        },
      ],

    };
  },


  mounted() {

    // 取得站台圖示
    this.fetchSiteFavicon();

    // 載入選單資料
    this.fetchLayout();

    // 字體大小
    const saved = localStorage.getItem('fontSize');
    if (saved) {
      this.currentSize = JSON.parse(saved);
    }
    document.documentElement.style.fontSize = this.currentSize.value;


    // 點擊其他區塊關閉
    document.addEventListener('click', this.handleClickOutside);


    // 子選單找li
    this.$nextTick(this.calculateRowInfo);
    window.addEventListener('resize', this.calculateAllOpenDropdowns);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);

    window.removeEventListener('resize', this.calculateAllOpenDropdowns);
  },

  computed: {
    // 顯示名稱一律由目前語系決定，避免把 zh_TW 等舊儲存值直接印在畫面上
    currentLanguage() {
      const languageLabelMap = {
        'zh-TW': '繁體中文',
        'zh_TW': '繁體中文',
        'en': 'ENGLISH',
        'en-US': 'ENGLISH',
        'en_US': 'ENGLISH',
        'ja': '日本語',
        'ja-JP': '日本語',
        'ja_JP': '日本語'
      };

      return languageLabelMap[this.$i18n.locale] || '繁體中文';
    }
  },

  watch: {
    '$i18n.locale': function() {
      // 語系切換時重新載入配置
      this.fetchSiteFavicon();
      this.fetchLayout();
    }
  },

  methods: {

    // 轉換前端語系名稱為後端格式
    convertLocaleForBackend(frontendLocale) {
      const localeMap = {
        'zh-TW': 'zh-tw',
        'en': 'en-us',
        'ja': 'ja-jp'
      };
      return localeMap[frontendLocale] || 'zh-tw';
    },

    // API: 取得站台圖示
    async fetchSiteFavicon() {
      try {
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/Frontend/GetSiteFavicon`;
        const response = await fetch(apiUrl);
        
        if (!response.ok) {
          console.warn('無法取得站台圖示，使用預設值');
          return;
        }
        
        const data = await response.json();
        
        if (data.faviconUrl) {
          this.logoUrl = `${this.$store.state.src}${this.$store.state.subDirectory}${data.faviconUrl}`;
        }
      } catch (error) {
        console.warn('載入站台圖示失敗，使用預設值:', error);
      }
    },

    // API: 取得版面配置
    async fetchLayout() {
      try {
        const backendLocale = this.convertLocaleForBackend(this.$i18n.locale);
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/Frontend/GetLayout?TabKey=HeaderFooter&locale=${backendLocale}`;
        const response = await fetch(apiUrl);
        
        if (!response.ok) {
          console.warn('無法取得版面配置，清空選單資料');
          this.menuItems = []; // 清空選單
          return;
        }
        
        const layout = await response.json();
        
        // 找到 MainMenu 項目
        const mainMenuItem = layout.layoutItems?.find(item => item.itemKey === 'MainMenu');
        
        if (mainMenuItem && mainMenuItem.referenceId) {
          await this.fetchMenuData(mainMenuItem.referenceId);
        } else {
          console.error('找不到 MainMenu 項目');
          this.menuItems = []; // 清空選單
        }
      } catch (error) {
        console.error('載入版面配置失敗:', error);
        this.menuItems = []; // 清空選單
      }
    },

    // API: 取得選單資料
    async fetchMenuData(menuId) {
      try {
        const backendLocale = this.convertLocaleForBackend(this.$i18n.locale);
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/Frontend/GetMenuData?MEId=${menuId}&locale=${backendLocale}`;
        const response = await fetch(apiUrl);
        
        if (!response.ok) {
          console.warn('無法取得選單資料，清空選單');
          this.menuItems = []; // 清空選單
          return;
        }
        
        const menu = await response.json();
        
        // 轉換選單資料格式
        if (menu.data && Array.isArray(menu.data)) {
          this.menuItems = this.transformMenuData(menu.data);
        } else {
          this.menuItems = []; // 清空選單
        }
      } catch (error) {
        console.error('載入選單資料失敗:', error);
        this.menuItems = []; // 清空選單
      }
    },

    // 轉換選單資料格式
    transformMenuData(menuData) {
      return menuData.map(item => {
        const menuItem = {
          title: item.text,
          link: this.generateLink(item.data),
          isExternal: item.data?.type === 3,
          target: item.data?.target || '_self',
          isOpen: false,
          lastInRowIndex: [],
          lastRowIndex: [],
        };

        // 如果有子選單
        if (item.childs && item.childs.length > 0) {
          menuItem.children = item.childs.map(child => ({
            title: child.text,
            link: this.generateLink(child.data),
            isExternal: child.data?.type === 3,
            target: child.data?.target || '_self',
          }));
        }

        return menuItem;
      });
    },

    // 根據 data.type 產生對應的連結
    generateLink(data) {
      if (!data) return '';

      switch (data.type) {
        case 0:
          // 目錄，不產生連結
          return '';
        case 1:
          // 文章分類
          return data.cid ? `/Category/${data.cid}` : '';
        case 2:
          // 文章
          return data.pid ? `/Post/${data.pid}` : '';
        case 3:
          // 外部連結
          return data.url || '';
        default:
          return '';
      }
    },

    toggleMenu() {
      this.isOpen = !this.isOpen;
    },

    // 字體大小
    selectSize(size) {
      this.currentSize = size;
      document.documentElement.style.fontSize = size.value;
      localStorage.setItem('fontSize', JSON.stringify(size));
    },

    // 語言切換
    toggleLanguage() {
      this.isLanguageOpen = !this.isLanguageOpen;
    },

    selectLanguage(item) {
      // 映射顯示名稱到 locale code
      const localeMap = {
        '繁體中文': 'zh-TW',
        'ENGLISH': 'en',
        '日本語': 'ja'
      };
      
      this.$i18n.locale = localeMap[item.label]; // 即時切換語言
      localStorage.setItem('language', item.label);
      this.isLanguageOpen = false;
    },

    handleClickOutside(e) {
      const wrap = this.$refs.languageWrap;
      if (!wrap) return;

      if (!wrap.contains(e.target)) {
        this.isLanguageOpen = false;
      }
    },



    // 選單找li
    toggleDropdown(index) {
      const item = this.menuItems[index];
      item.isOpen = !item.isOpen;

      this.$nextTick(() => {
        if (item.isOpen) {
          this.calculateRowInfo(index);
        }
      });
    },

    calculateRowInfo(menuIndex) {
      const item = this.menuItems[menuIndex];
      const els = this.$refs[`childItem-${menuIndex}`];

      if (!els || !els.length) return;

      item.lastInRowIndex = [];
      item.lastRowIndex = [];

      // 每行最後一個
      els.forEach((el, index) => {
        const next = els[index + 1];
        if (!next || next.offsetTop !== el.offsetTop) {
          item.lastInRowIndex.push(index);
        }
      });

      // 最後一行所有
      const maxTop = Math.max(...els.map(el => el.offsetTop));
      els.forEach((el, index) => {
        if (el.offsetTop === maxTop) {
          item.lastRowIndex.push(index);
        }
      });
    },

    calculateAllOpenDropdowns() {
      this.menuItems.forEach((item, index) => {
        if (item.children && item.isOpen) {
          this.calculateRowInfo(index);
        }
      });
    },




  },


}

</script>
